import { render } from "./CarriersList.vue?vue&type=template&id=2e71aa26&scoped=true&ts=true"
import script from "./CarriersList.vue?vue&type=script&lang=ts"
export * from "./CarriersList.vue?vue&type=script&lang=ts"

import "./CarriersList.vue?vue&type=style&index=0&id=2e71aa26&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e71aa26"]])

export default __exports__